import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWR from "swr";
const getCustomerLead = async (id) => {
  return await jwtAxios.get(`${URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEAD}/${id}`);
};
const useGetCustomerLead = (id) => {
  const key = {
    url: URL_API.CMS_CUSTOMER_LEADS.GET_CUSTOMER_LEAD,
    id,
    tags: [`#customerLeadId:${id}`],
  };
  const fetcher = () => getCustomerLead(id);
  return useSWR(key, fetcher);
};
export default useGetCustomerLead;
